import _ from 'lodash';
import axios from 'axios';
import siteConfig from '../config/site.config';
import {
  getAuthenticateData,
  removePersistentData,
  updateTokenPersistentData,
} from '../library/helpers/utility';
import { PRIVATE_ROUTE, PUBLIC_ROUTE } from '../route.constants';

const AUTHORIZATION_HEADER = 'Authorization';
const X_REFRESH_TOKEN_HEADER = 'x-refresh-token';

const request = axios.create({
  baseURL: siteConfig.apiUrl,
  timeout: 100000 * 10,
  headers: {
    SecretKey: siteConfig.secretKey,
    'Content-Type': 'application/json',
  },
});

request.interceptors.request.use(
  (config) => {
    const userData = getAuthenticateData();
    let newConfig = {
      ...config,
    };

    if (!_.isNil(userData)) {
      newConfig.headers.common[
        AUTHORIZATION_HEADER
      ] = `Bearer ${userData.authenticate.accessToken}`;
      newConfig.headers.common[
        X_REFRESH_TOKEN_HEADER
      ] = `Bearer ${userData.authenticate.refreshToken}`;
    }

    return newConfig;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    if (response.data && response.data.scaCredentials) {
      const { refreshToken, accessToken } = response.data.scaCredentials;
      updateTokenPersistentData(refreshToken, accessToken);
    }

    return response;
  },
  (error) => {
    // Verifico se ottengo una risposta 404 con contenuto HTML
    if (
      (error?.response?.status === undefined &&
        error?.message === 'Network Error') ||
      (error?.response?.status === 404 &&
        error?.response?.request?.responseHeaders['Content-Type'] ===
          'text/html;charset=utf-8')
    ) {
      removePersistentData();
      window.location.pathname =
        siteConfig.basename + PUBLIC_ROUTE.ERROR_NETWORK;
    }

    const wrongCredentialsErrorsRegex = new RegExp('^401_2_(5|6|7|8|9)$', 'gm');

    if (error.response && error.response.status === 401) {
      if (error.response.data.slException.code === '401_2_9') {
        if (window.location.pathname !== '/profile') {
          window.location.pathname =
            siteConfig.basename + PRIVATE_ROUTE.MY_PROFILE;
        }
      } else {
        if (
          error.response.data.slException.code === '401_2_10' ||
          !wrongCredentialsErrorsRegex.test(
            error.response.data.slException.code
          )
        ) {
          if (!Object.values(PUBLIC_ROUTE).includes(window.location.pathname)) {
            removePersistentData();
            window.location.pathname = window.location.pathname;
          }
        }
      }
    }
    return Promise.reject(error);
  }
);

export default request;
